import { useEffect, useState } from 'react';
import styled from 'styled-components';
import scrollToElement from 'scroll-to-element';
import { getFeatures, getCoefficient, getTerrainProfile, getPolygonVolume,saveFeatures, deleteProject, calculateFeatures } from '../../services/projectService';
import SurfaceChart from './SurfaceChart'
import ProfileChart from './ProfileChart'
import FeatureForm from './featureForm';
import FeatureGrid from './FeatureGrid';
import Icon from '../StoraEnsoComponents/Icon';
import Button  from '../StoraEnsoComponents/Button';
import { DRONE_MAP } from '../../Routes';
import { useNavigate } from 'react-router-dom';
import NotificationToast from '../NotificationToast';
import ConfirmationModal from '../ConfirmationModal';
import Map from '../Map';
import { DroneDetailProvider, useDroneDetailContext } from '../Contexts/DroneDetailContext';
import { SidebarWrapper as DefaultSidebarWrapper, Sidebar }  from '../Sidebar';
import { ReactComponent as ArrowUpSvg } from '../../assets/icons/angle-up.svg';
import NotificationUnsavedChanges from '../NotificationUnsavedChanges';

const OpenIcon = styled(ArrowUpSvg)``;

const SidebarWrapper = styled(DefaultSidebarWrapper)`
  margin-bottom: 32px;
`;

const FeatureFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 8px 32px 8px;
`;

const OpenSidebarBtn = styled(Button)`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(0, -109px) rotate(-90deg);
  transform-origin: bottom right;
`;
const ChartWrapper = styled.div`
  position: relative;
  justify-content: center;
  display: flex;
  border-style: groove;`

const CloseIcon = styled(Icon)`
  position: absolute;
  top: 1rem;
  right: 1rem;
  cursor: pointer;
`;

function MillDetail({ projectData}) {
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(true);
  const [profileChartData, setProfileChartData] = useState(null);
  const [areaChartData, setAreaChartData] = useState();
  const [lineData, setLineData] = useState([]);
  const [areaData, setAreaData] = useState([]);
  const [config, setConfig] = useState();
  const [actionResult, setActionResult] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();
  const {featuresData, setFeaturesData, selectedFeature, setSelectedFeature, setUnsavedChanges, unsavedChanges} = useDroneDetailContext();

  useEffect(() => {
    console.log(projectData)
    Promise.all([
      getFeatures(projectData.id)
        .then(data => {
          setFeaturesData(data);
          setLineData(data.filter(item => item.geometry.type === "LineString"));
          setAreaData(data.filter(item => item.geometry.type === "Polygon"));

          if(data.length > 0) {
            setSelectedFeature(data[0]);
          }

        }),
      getCoefficient(projectData.id)
        .then(data => setConfig(data)),

    ])
      .catch(() => setError())
      .then(() => {
        setLoading(false);
        scrollToElement('#map', {
          offset: -100,
          duration: 500,
        });
      })
  }, []);

  // clear chart data on selectedFeature change
  useEffect(() => {
    if(selectedFeature) {
      setAreaChartData(null);
      setProfileChartData(null);
    }
  }, [selectedFeature]);

  const applyChanges = updatedFeature => {
    console.log("updated",updatedFeature)
    setFeaturesData(prev => prev.map(item => item.properties.id !== updatedFeature.properties.id ? item : updatedFeature));
    setSelectedFeature(updatedFeature);
  }

  const calculateFeature = (feature) =>{

    setUnsavedChanges(true);
    if(feature.geometry.type ==='Polygon'){
      getPolygonVolume(feature).then( data => {
        console.log(data);
        feature.properties.area_m2 = data.area?.toFixed(2);
        feature.properties.volume_m3 = data.volume?.toFixed(2);
        feature.properties.volume_coef_m3 = (feature.properties.volume_m3*feature.properties.coeficient).toFixed(2);
        applyChanges(feature);
        setProfileChartData(null)
        setAreaChartData({data:data,feature:feature});
      })
      .catch(() => {
        setActionResult({
          kind: 'error',
          message: 'An error has occurred while calculating feature!'
        });
      });

      return;
    }

    getTerrainProfile(feature).then( data => {
      feature.properties.area_m2 = data.area.toFixed(2);
      feature.properties.volume_m3 = (data.area*feature.properties.log_length).toFixed(2);
      feature.properties.volume_coef_m3 = (feature.properties.volume_m3*feature.properties.coeficient).toFixed(2);
      applyChanges(feature);
      setAreaChartData(null)
      setProfileChartData({data:data,feature:feature});
    })
    .catch(() => {
      setActionResult({
        kind: 'error',
        message: 'An error has occurred while calculating feature!'
      });
    });
  }

  const updateStatus = () => {
    deleteProject(projectData.id)
      .then(() => {
          navigate(DRONE_MAP)
      })
      .catch(() => {
        setActionResult({
          kind: 'error',
          message: 'An error has occurred while deleting project!'
        });
      });
  }
  const saveProjectFeatures = ()=>{
    saveFeatures(projectData.id,featuresData)
    .then(() => {
      setUnsavedChanges(false);
      setActionResult({
        kind: 'success',
        message: 'Features has been successfully saved.'
      });
    })
    .catch(() => {
      setActionResult({
        kind: 'error',
        message: 'An error has occurred while saving features'
      });
    });
  }

  const handleCalculateFeatures = () =>{
    console.log(featuresData);
    let calculatedFeatures=[]
    setLoading(true)
    calculateFeatures(featuresData).then(data=>{
      data.forEach(d=>{
        let feature = featuresData.find(feature=>feature.properties.id===d.id)
        if(feature.geometry.type ==='LineString'){
          feature.properties.area_m2 = d.area.toFixed(2);
          feature.properties.volume_m3 = (d.area*feature.properties.log_length).toFixed(2);
          feature.properties.volume_coef_m3 = (feature.properties.volume_m3*feature.properties.coeficient).toFixed(2);
        }
        if(feature.geometry.type ==='Polygon'){
          feature.properties.volume_m3 = d.volume.toFixed(2);
          feature.properties.volume_coef_m3 = (feature.properties.volume_m3*feature.properties.coeficient).toFixed(2);
        }
        calculatedFeatures.push(feature);
      })
      console.log(calculatedFeatures);
      setFeaturesData(calculatedFeatures);
      setLoading(false)
    })
    .catch(() => {
      setActionResult({
        kind: 'error',
        message: 'An error has occurred while calculating all features!'
      });
    });
  }

  return (
    <>
      <NotificationUnsavedChanges
        isOpen={unsavedChanges}
        onSave={saveProjectFeatures} />

      <NotificationToast
        toastId="millDetail"
        kind={actionResult?.kind}
        message={actionResult?.message}
        onClose={() => setActionResult(null)}
      />
          <ConfirmationModal
        isOpen={isModalOpen}
        kind="error"
        title="Project Delete"
        okBtnLabel="Confirm"
        onClose={() => setModalOpen(false)}
        onSubmit={() => {
          updateStatus();
          setModalOpen(false);
        }}
        >
          Do you really want to DELETE this project? This action can not be reversed.
      </ConfirmationModal>

      <SidebarWrapper>
        <Map projectData={projectData}
          lineData={lineData}
          areaData={areaData}
          pointData={[]}/>

        <OpenSidebarBtn icon={<OpenIcon />} onClick={() => setSidebarVisible(true)}>Show</OpenSidebarBtn>
        <Sidebar visible={sidebarVisible}>
          <FeatureFormWrapper>
            <CloseIcon role="button" onClick={() => setSidebarVisible(false)}>close</CloseIcon>
            <FeatureForm
              config={config}
              onFormSubmit={(values) => calculateFeature(values)}
              onApplyChanges={applyChanges}
              projectId={projectData.id}
            />
          </FeatureFormWrapper>
        </Sidebar>
      </SidebarWrapper>
      {
        (areaChartData || profileChartData) && (
          <ChartWrapper>
            {areaChartData && <SurfaceChart data={areaChartData}/>}
            {profileChartData && <ProfileChart data={profileChartData}/>}
            <CloseIcon role="button" onClick={()=>{setAreaChartData(null); setProfileChartData(null)}}>close</CloseIcon>
          </ChartWrapper>
      )}
      <FeatureGrid
        loading={loading}
        onCalculateAllFeatures={() => {handleCalculateFeatures()}}
        projectData={projectData} />
    </>
  );


}

export default function DroneDetailWithContext({projectData}) {
  return (
    <DroneDetailProvider>
      <MillDetail projectData={projectData}/>
    </DroneDetailProvider>
  );
};